export default "__VITE_ASSET__7906263d__"